module.exports = "<div style=\"padding: 20px 0;\">\n    <div class=\"sk-spinner sk-spinner-chasing-dots\">\n        <div class=\"sk-dot1\"></div>\n        <div class=\"sk-dot2\"></div>\n    </div>\n</div>";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/loading/template.html
// module id = 1262
// module chunks = 0